// Canonical list of views that appear in the RBAC permission matrix.
// Imported by AdminPage (for the RBAC builder) and ApiKeysPage (for the
// per-key permissions table).  Keeping it here avoids duplication between
// the two pages; both need the same complete list.
export const ALL_VIEWS = [
  { id: 'home', label: 'Home / Dashboard' },
  { id: 'kql', label: 'KQL Library' },
  { id: 'verify', label: 'Verification Queue' },
  { id: 'mitre', label: 'ATT&CK Coverage' },
  { id: 'decisions', label: 'Decision Trees' },
  { id: 'ai', label: 'AI Assistant' },
  { id: 'handoff', label: 'Shift Handoff' },
  { id: 'checklist', label: 'Daily Checklist' },
  { id: 'customers', label: 'Client Management' },
  // Dedicated row (NOT an alias to 'customers'): onboarding writes to Patriot's
  // central Sentinel workspace via managed identity — a higher privilege than
  // editing customer records. Aliasing would silently grant Sentinel writes to
  // every existing custom role that has canEdit on Client Management.
  { id: 'onboarding', label: 'Customer Onboarding' },
  { id: 'glossary', label: 'Glossary' },
  { id: 'lms', label: 'Training (LMS)' },
  { id: 'projects', label: 'Projects (incl. Calendar)' },
  { id: 'tasks', label: 'Tasks' },
  { id: 'pm-advanced', label: 'PM — advanced (Workload)' },
  { id: 'tickets', label: 'Tickets' },
  { id: 'reports', label: 'Reports' },
  { id: 'ir', label: 'Incident Response' },
  { id: 'threatHunting', label: 'Threat Hunting' },
  { id: 'engineering', label: 'Engineering (MXDR Engineers)' },
  { id: 'freshservice', label: 'FreshService' },
  // 'customerPortal' has no dedicated row — it aliases to 'customers' via
  // RBAC_VIEW_ALIAS (umbrella permission; see featureVisibility.ts).
  { id: 'knowledge-base', label: 'Knowledge Base' },
  { id: 'roster-mgmt', label: 'Roster Management' },
  { id: 'coverage', label: 'Shift Coverage (IC)' },
  { id: 'qa', label: 'QA Scores (analyst view)' },
  { id: 'qa_admin', label: 'QA Administration' },
  { id: 'signin-log', label: 'Sign-In Log' },
  { id: 'feature_requests', label: 'Feature Requests' },
  // Tier 3 access-request workflow (Engineering blade tab). canView shows the
  // tab; canEdit allows submitting requests. Approvals stay admin-only.
  { id: 'permission_requests', label: 'Access Requests (Tier 3)' },
  { id: 'api_keys', label: 'API Keys' },
  // General Management (GM-tier surface — RMS→Hub integration, Phase 1).
  // Dedicated rows so admins can grant individual GM views to other leads.
  { id: 'gm', label: 'GM Dashboard' },
  { id: 'traction', label: 'EOS / Traction' },
  { id: 'hiring', label: 'Hiring' },
  { id: 'people', label: 'People (GM)' },
  { id: 'discipline', label: 'Discipline' },
  { id: 'exec-reports', label: 'Executive Reports' },
] as const;
